import { Button, useToast } from "alm-react-components";
import { useTranslation } from "react-i18next";
import { constants, Tag } from "../../assets/constants/constants";
import arrowrightImg from "../../assets/images/svgicons/arrow-right.svg";
import React from "react";

type PlayButtonProps = {
  courseType: any | null;
  handleVideo: (btnType?:any) => void;
};

const PlayButton = ({ courseType, handleVideo }: PlayButtonProps) => {
  const { t } = useTranslation();
  const { dismiss } = useToast()

  const handleplayIcon = (courseType: any) => {
    switch (courseType) {
      case constants.VIDEOS:
        return t("HanldePlayButton.viewVideo");
        break;
        case constants.RECOMMENDED:
          return t("HanldePlayButton.viewrecommended");
          break;
      case constants.BULLETINS:
        return t("HanldePlayButton.bulletin");
        case constants.DOCUMENTS:
          return t("HanldePlayButton.document");
        break;
      case constants.BOOKS:
        return t("HanldePlayButton.book");
        break;
      case constants.PODCAST:
        return t("HanldePlayButton.podcast");
        break;
      case constants.DOCUMENT:
        return t("HanldePlayButton.document");
        break;
      case constants.MEETING: case Tag.liveclass:
        return t("HanldePlayButton.meeting");
        break;
      case constants.EXERCISE:
        return t("HanldePlayButton.exercise");
        break;
      case constants.recording:
        return t("HanldePlayButton.watchRecordedMeeting");
        break;
      case constants.meetingAlreadyCompleted:
        return t("HanldePlayButton.meetingAlreadyCompleted");
        break;
      default:
       return t("HanldePlayButton.defaultCase");
    }
  };
  return (
    <Button
      className="flex absolute justify-center p-5 items-center cursor-pointer course-play-div"
      variant="outline"
      onClick={() => {
        dismiss();
        handleVideo(courseType);
      }}
    >
      {handleplayIcon(courseType)}
      <img src={arrowrightImg} alt={" "} className="logo ms-3 text-sm" />
    </Button>
  );
};

export default React.memo(PlayButton);
